/*
 * Author: Alexandre Ferri
 * Created on Mon Jun 03 2019
 *
 * Copyright (c) 2019 Zapala Corp
 */

import React from "react";

import * as Sentry from "@sentry/react";
import ReactDOM from "react-dom";
import { pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

import { Application } from "./App";
import AppStateProvider from "./context/StateContext";
import { setupSentry } from "./services/sentry.service";
import "./translate";

setupSentry();

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

ReactDOM.render(
  <Sentry.ErrorBoundary>
    <AppStateProvider>
      <Application />
    </AppStateProvider>
  </Sentry.ErrorBoundary>,
  document.getElementById("root")
);
